import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Eye, Trash2 } from "react-feather";
import TooltipIcons from "../../common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../common/tooltip-content/refresh";
import CollapesIcon from "../../common/tooltip-content/collapes";
import { useDeleteSupplierMutation, useGetAllSupplierQuery } from "../../redux/api/userApi";
import Table from "../../pagination/datatable";
import SupplierModal from "./supplierModal";
import CommonDeleteModal from "../../common/modal/commonDeleteModal";
import toast from "react-hot-toast";

const SupplierList = () => {
  const {data: supplierResponse, refetch} = useGetAllSupplierQuery();
  const [deleteSupplier] = useDeleteSupplierMutation();
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [isAddMode, setIsAddMode] = useState(false);
  const [deleteSupplierId, setDeleteSupplierId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeleteSupplier = async () => {
    if (!deleteSupplierId) {
      console.error("No supplier ID provided for deletion");
      return;
    }
    
    try {
      await deleteSupplier(deleteSupplierId).unwrap();
      toast.success("Supplier Deleted Successfully");
      refetch(); // Refresh the supplier list
    } catch (error) {
      toast.error("Unable to delete Supplier");
      // alert(`Unable to delete Supplier: ${error.message}`);
    } finally {
      setShowDeleteModal(false);
      setDeleteSupplierId(null);
    }
  }
  const openDeleteModal = (id) => {
    setDeleteSupplierId(id);
    setShowDeleteModal(true);
  }
  const columns = [
    {
      title: "Supplier Code",
      dataIndex: "supplierCode",
      sorter: (a, b) => a.supplierCode.length - b.supplierCode.length,
      responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
    },
    {
      title: "Supplier Name",
      dataIndex: "supplierName",
      sorter: (a, b) => a.supplierName.length - b.supplierName.length,
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'], // Always visible
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a, b) => a.phone.length - b.phone.length,
      responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length,
      responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
    },
    {
      title: "Address",
      dataIndex: "address",
      responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal" 
              data-bs-target="#add-supplier"
              onClick={() => {
                setSelectedSupplier(record);
                setIsAddMode(false);     
              }}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link
              className="confirm-text p-2"
              onClick={(e) => {
                e.preventDefault();
                openDeleteModal(record._id);
              }}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'], // Always visible
    },
];
const excelOptions = {
  fileName: 'Supplier_List',
  sheetName: 'Suppliers',
  columns: [
    { key: 'supplierCode', header: 'Supplier Code' },
    { key: 'supplierName', header: 'Supplier Name' },
    { key: 'phone', header: 'Phone' },
    { key: 'email', header: 'Email' },
    { key: 'address', header: 'Address' }
  ],
  data: supplierResponse?.map(supplier => ({
    supplierCode: supplier.supplierCode,
    supplierName: supplier.supplierName,
    phone: supplier.phone,
    email: supplier.email,
    address: supplier.address
  })) || []
};

const pdfOptions = {
  fileName: 'Supplier_List',
  title: 'Supplier List',
  columns: [
    { key: 'supplierCode', header: 'Supplier Code' },
    { key: 'supplierName', header: 'Supplier Name' },
    { key: 'phone', header: 'Phone' },
    { key: 'email', header: 'Email' },
    { key: 'address', header: 'Address' }
  ],
  data: supplierResponse?.map(supplier => ({
    supplierCode: supplier.supplierCode,
    supplierName: supplier.supplierName,
    phone: supplier.phone,
    email: supplier.email,
    address: supplier.address
  })) || [],
  fileNamePrefix: 'Suppliers'
};
const expandable = {
    expandedRowRender: (record) => (
        <div style={{ padding: '10px' }}>
            <p><strong>Supplier Code:</strong> {record.supplierCode || "-"}</p>
            <p><strong>Phone:</strong> {record.phone || "-"}</p>
            <p><strong>Email:</strong> {record.email || "-"}</p>
            <p><strong>Address:</strong> {record.address || "-"}</p>
        </div>
    ),
    rowExpandable: (record) => true,
    expandRowByClick: true,
};

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>SupplierList</h4>
                <h6>Manage your SupplierList</h6>
              </div>
            </div>
            <ul className="table-top-head">
                          <TooltipIcons excelOptions={excelOptions} pdfOptions={pdfOptions}/>
              <RefreshIcon />
              <CollapesIcon />

            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-supplier"
                onClick={() => {
                  setSelectedSupplier(null); // Clear selection
                  setIsAddMode(true);       // Set to add mode
                }}
              >
              <i className='ti ti-circle-plus me-1'></i>
                Add Supplier
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set">
              </div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                     Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Inactive
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        New Joiners
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <Table
                  className="table datanew"
                  columns={columns}
                  expandable={expandable}
                  dataSource={supplierResponse}
                  key={supplierResponse?._id}
                  // rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>

            <SupplierModal
        isEdit={!isAddMode}          // true=edit, false=add
        supplierData={selectedSupplier} // null=add, object=edit
        onSuccess={() => {
          // Refresh data after success
          setSelectedSupplier(null);
            refetch();
        }}
      />
       {/* <SupplierModal/> */}
       
       {showDeleteModal && (
        <div className="modal fade show" id="delete-modal" style={{display: 'block'}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-5">
              <div className="modal-body text-center p-0">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger" />
                </span>
                <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                  Delete Supplier
                </h4>
                <p className="text-gray-6 mb-0 fs-16">
                  Are you sure you want to delete this supplier?
                </p>
                <div className="d-flex justify-content-center mt-3">
                  <button
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                    onClick={handleDeleteSupplier}
                  >
                    Yes Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>

  );
};

export default SupplierList;
